import React from "react"
import type { TimeRange, RangePickerOption } from "../types"

interface PilotTrackingRangePickerProps<T> {
    options: RangePickerOption<T>[]
    onChange: (value: RangePickerOption<T>) => void
    value: T
}

const PilotTrackingRangePicker = <T extends TimeRange>({
    onChange,
    options,
    value,
}: PilotTrackingRangePickerProps<T>) => {
    return (
        <div className="flex items-center gap-2">
            {options.map((option) => (
                <button
                    key={option.value}
                    className="text-white-600 py-1 px-2 rounded-md data-[active=true]:bg-blue-900 data-[active=true]:text-white text-xs"
                    data-active={option.value === value}
                    onClick={() => onChange(option)}
                >
                    {option.title}
                </button>
            ))}
        </div>
    )
}

export { PilotTrackingRangePicker }
